export function initialPhase1RunState(runId = null) {
  return {
    runId,
    status: 'idle',
    lastSequence: -1,
    text: '',
    responseParts: [],
    blocks: [],
    activity: [],
    workStatus: null,
    workStatusRevision: -1,
    publicTimeline: [],
    citations: [],
    memoryIds: [],
    mock: false,
    messageId: null,
    assistantMessageId: null,
    error: null,
  }
}
